(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .factory('swifPatrimoineEquipmentService', swifPatrimoineEquipmentService)
    .controller('PatrimoineEquipmentController', PatrimoineEquipmentController)
    .directive('panelPatrimoineEquipment', panelPatrimoineEquipment)
    .controller('PatrimoineEquipmentsController', PatrimoineEquipmentsController)
    .component('patrimoineEquipmentsTable', {
        templateUrl: 'partials/patrimoine/patrimoine_equipment_table.html',
        controller: PatrimoineEquipmentsController,
        bindings: {
            parentModel: '<'
        }
    });


    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineEquipmentService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineEquipmentService(swif) {
        'ngInject';
        var service = {};
        service.swif = swif;

        service.getCollection = function () {
            return swif.collections.getCollection('patrimoine_sites_equipments');
        };

        service.preModal = function (data) {
            service.getCollection().preModal(data);
        };
        service.preValidate = function (data) {
            if (data.model.equipment_reference != undefined && data.model.equipment_reference === 0) {
                delete data.model.equipment_reference;
            }
            if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_product_id;
            }
            swifOpenbaseCustomFieldsService.sanitize(data);
            return service.getCollection().preValidate(data);
        };
        service.callback = function (error, data) {
            service.getCollection().defaultActionCallback(error, data);
        };
        return service;
    }

    function PatrimoineEquipmentsController(dataService, $scope, $q, $location, swif, openbase, patrimoine, swifDownloadService) {
        'ngInject';
        var $ctrl = this;
        console.log('init PatrimoineEquipmentsController');
        $scope.STATES = {};
        var statesConfig = openbase.equipment.getStatesConfig();
        _.forEach(statesConfig, function (item) {
            $scope.STATES[item.id] = item.name;
        });
        $ctrl.preModal = preModal;
        $ctrl.preValidate = preValidate;
        $ctrl.callback = callback;
        $ctrl.$onChanges = function (changes) {
            if (changes.parentModel) {
                getEquipments();
            }
        };
        getEquipments();
        function parentIsSite() {
            return ($ctrl.parentModel._type === 'patrimoine_site') || ($ctrl.parentModel._type === 'site');
        }
        function parentIsEqpt() {
            return $ctrl.parentModel._type === 'patrimoine_equipment';
        }
        function getEquipments() {
            // if a filter is defined in $location, use it directly,
            // if not, prepare the collection filter
            var filter = {};
            var locFilter = $location.search().equipmentsFilter;
            if (locFilter) {
                filter = angular.copy(JSON.parse(locFilter));
                // remove the filter from $location once we used it
                $location.search('equipmentsFilter', null);
            } else {
                swif.data.sortOn(filter, 'name', 'ASC');
                if (parentIsSite()) {
                    swif.data.addExtraFilter(
                        filter, 'site', 'site_id', '=', $ctrl.parentModel.id
                    );
                } else if (parentIsEqpt()) {
                    swif.data.addExtraFilter(
                        filter, 'site', 'parent_id', '=', $ctrl.parentModel.id
                    );
                }
            }
            return swif.collections.createOrUpdate(
                'patrimoine_sites_equipments',
                'patrimoine_equipment',
                filter
            ).then(function (collection) {
                $ctrl.equipments = collection;
                return collection;
            });
        }

        function preModal(data) {
            if (data.action.id === 'add') {
                if (parentIsSite()) {
                    data.model.site_id = [
                        $ctrl.parentModel.id,
                        $ctrl.parentModel.name
                    ];
                } else if (parentIsEqpt()) {
                    data.model.parent_id = [
                        $ctrl.parentModel.id,
                        $ctrl.parentModel.name
                    ];
                }
                swif.data.callKw('equipment', 'increment_equipment_reference').then(function (res) {
                    if (res.next_equipment_ref && _.isNumber(res.next_equipment_ref)) {
                        data.model.equipment_reference = res.next_equipment_ref;
                    }
                });
            }
            return patrimoine.equipment.preModal(data)
        }

        function preValidate(data) {
            if (data.model.equipment_reference != undefined && data.model.equipment_reference === 0) {
                delete data.model.equipment_reference;
            }
            if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_product_id;
            }
            openbase.equipment._prepareNewQty(data);

            // -- specifique controls for 'patrimoine_equipment' item(s) to print
            // TODO :factoriser dans barcode.js ? avec le preValidate de collection.js
            var barcodeService = openbase.barcode;
            if (data.action.id === 'print_collection') {
                var ids = _.pluck(data.model.items, 'id');
                var filter = {};
                dataService.addFilter(filter, 'res_id', 'in', ids);
                dataService.addFilter(filter, 'res_model', '=', 'openstc.equipment');
                dataService.get('openbase_barcode', undefined, filter)
                    .then(function (barcodeData) {
                        barcodeService.changeContextWithBarcodeIds(data.model.context, barcodeData);
                        var barcodeIds = _.pluck(barcodeData, 'id');
                        barcodeService.downloadReport(barcodeIds, data.model);
                    });
            }
            if (data.action.id==='print'){
                var filter = {};
                dataService.addFilter(filter, 'res_id', 'in', [data.model.id]);
                dataService.addFilter(filter, 'res_model', '=', 'openstc.equipment');
                dataService.get('openbase_barcode', undefined, filter)
                    .then(function (barcodeData) {
                        barcodeService.changeContextWithBarcodeIds(data.model.context, barcodeData);
                        barcodeService.downloadReport([barcodeData[0].id], data.model);
                    });
            }
            return true;
        }

        function callback(error, data) {
            if (error) {
                return;
            }
            var model, action;
            function prepareModel(data) {
                return {
                    name: swif.i18n.getString('Replace') + ' ' + data.model.name,
                    // site1: data.model.site_id,
                    equipment_id: [data.model.id, data.model.complete_name || data.model.name]
                };
            }
            function _callback(error, data) {
                swif.collections.defaultCallbackMessage(error, data);
            }
            if (data.action.id === 'add_intervention_request') {
                model = prepareModel(data);
                action = swif.action.getActionById(
                    'intervention_request',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention_request', action, model,
                    {callback: _callback}
                );
            } else if (data.action.id === 'add_intervention') {
                model = prepareModel(data);
                action = swif.action.getActionById(
                    'intervention',
                    'list', 'add'
                );
                swif.action.dispatch(
                    'intervention', action, model,
                    {callback: callback}
                );
            } else if ($ctrl.equipments) {
                $ctrl.equipments.defaultActionCallback(error, data);
            }
        }

    }

    function PatrimoineEquipmentController($scope, swif, openbase, carto) {
        'ngInject';
        $scope.modules = swif.module.modules;
        if (!$scope.model.custom_fields) {
            $scope.model.custom_fields = [];
        }

        // #3069 temporary boolean for customFields
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;

        $scope.equipmentReferenceAlreadyExist = false;
        $scope.showMore=false;
        $scope.showMoreModel = function () {
            $scope.showMore=!$scope.showMore;
        };

        $scope.filters = {
            supplier: {},
            category: {fields: ['complete_name', 'is_equipment', 'is_vehicle', 'is_fluid_meter', 'parent_id']},
            parent_id: {fields:  ['id', 'name', 'complete_name', 'equipment_reference']}
        };

        if ($scope.model.categ_id && !$scope.model._categ_id) {
            swif.data.get('equipment_category', $scope.model.categ_id[0])
            .then(function (category) {
                $scope.model._categ_id = category;
            });
        }
        if ($scope.model.id) {
            swif.data.addFilter($scope.filters.parent_id, 'id', '!=', $scope.model.id);
        }
        $scope.onCategoryChange = function (category) {
            $scope.model._categ_id = category;
            $scope.fluidsMeterAndModule = $scope.modules.opengst_fluide && category.is_fluid_meter;
        };

        $scope.$watch('model.categ_ids', function (newV, oldV) {
            let categ_id = _.difference(newV,oldV);
            if (categ_id) {
                swif.data.get('equipment_category', categ_id[0]).then(category => {
                    $scope.model.custom_fields = _.union($scope.model.custom_fields, category.custom_fields)
                });
            }
        });

        $scope.goToFluidsMetersPanel = function () {
            // same action as clicking on "cancel" button of the generic modal
            $scope.$parent.$parent.cancel();
        }

        swif.data.addFilter($scope.filters.supplier, 'type_id.product_supplier', '=', true);
        $scope.choices = {states: openbase.equipment.getStatesConfig()};
        $scope.STATES = {};
        _.forEach($scope.choices.states, function (item) {
            $scope.STATES[item.id] = item.name;
        });

        // equipment.state undefined for creation
        if (!$scope.model.state){
            $scope.model.state = [false, $scope.STATES[false]];
        }

        $scope.$watch('model.state', function (newV) {
            if (_.isString(newV)) {
                $scope.model.state = [newV, $scope.STATES[newV]];
            }
        });
        $scope.$watch('model.life_duration', function (newV) {
            if (newV) {
                if ($scope.model.date_start) {
                    //compute date end;
                    $scope.model.date_end = moment($scope.model.date_start)
                        .add(newV, 'month')
                        .format('YYYY-MM-DD');
                }
            }
        });
        $scope.$watch('model.equipment_reference', function(newV, oldV) {
            if (newV !== oldV) {
                var params = {
                    fields: ['id'],
                    domain: [
                        '&',
                        ['equipment_reference', '!=', false],
                        ['equipment_reference', '=', newV]
                    ]
                };

                if ($scope.model._type === 'patrimoine_equipment' && $scope.model.id) {
                    params.domain.push(['id', '!=', $scope.model.id]);
                }

                swif.data.searchRead('equipment', params).then(function(matchedEquipmentCodes) {
                    if (matchedEquipmentCodes.ids.length > 0) {
                        $scope.equipmentReferenceAlreadyExist = true;
                        $scope.matchedEquipment = matchedEquipmentCodes.ids[0];
                    } else {
                        delete $scope.matchedEquipment;
                        $scope.equipmentReferenceAlreadyExist = false;
                    }

                    $scope.form['model.equipment_reference'].$setValidity(
                        'default',                          // default don't exist: just highlight the field in red without any message
                        matchedEquipmentCodes.ids.length === 0  // if there is no matched site found
                    );
                });
            }
        });

        if (!swif.module.modules.opengst_carto) {
            return;
        }
        $scope.showLeaflet = false;
        $scope.onMapInitialized = onMapInitialized;
        if ($scope.model.osm_zoom) {
            $scope.model._osm_zoom = $scope.model.osm_zoom;
        }
        $scope.fixHiddenLeaflet = function () {
            setTimeout(function () {
                $scope.showLeaflet = true;
                $scope.$apply();
            }, 200);
        };
        $scope.$watch('model._osm_zoom', setZoom);
        function onMapInitialized (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                map.setZoom($scope.model.osm_zoom);
            }
        }
        function setZoom (zoom) {
            if (zoom === undefined) {
                $scope.model.osm_zoom = swif.settings.app.leaflet.center.zoom;
            } else {
                $scope.model.osm_zoom = zoom;
                if ($scope.map) {
                    $scope.map.setZoom(zoom);
                }
            }
        }
    }


    function panelPatrimoineEquipment(swif, swifRouteService, swifCartoLeafletService, openbase) {
        'ngInject';
        var linked = function(scope, element, attr, ngModel) {

            var initGeoPoint = function() {
                //reset
                scope.extra = {};
                scope.route = swifRouteService;
                scope.geoloc = false;
                // Carte
                if (scope.item.geo_point) {
                    scope.geoloc = true;
                }
            }
            var render = ngModel.$render;
            ngModel.$render = function () {
                render();
                initGeoPoint();
            };
            initGeoPoint();

            scope.route = swifRouteService;
            swif.attachment.addAttachments(scope.item);

            scope.setDisplay = function (content) {
                if (content==='geoloc'){
                    this.route.check({resources: ['leaflet']}).then(function () {
                        scope.extra = content;
                    });
                }else{
                    scope.extra = content;
                }
            };

            scope.onMapInitialized = function (map) {
                scope.map = map;
                if (scope.item.osm_zoom) {
                    scope.map.setZoom(scope.item.osm_zoom);
                }
                if (scope.item.geo_point) {
                    let marker = swifCartoLeafletService.getMarkerFromPoint(scope.item.geo_point);
                    if (marker) {
                        marker.addTo(scope.map);
                        scope.map.setView(marker.getLatLng());
                    }
                }
            };

            scope.STATES = {};
            var statesConfig = openbase.equipment.getStatesConfig();
            _.forEach(statesConfig, function (item) {
                scope.STATES[item.id] = item.name;
            });

            //use for panelModel
            scope.showMore=false;
            scope.showMoreModel = function () {
                scope.showMore=!scope.showMore;
            };
            scope.$watch('item', function (newV) {
                if (newV) {
                    scope.showMore=false;
                }
            });
        };
        var directive = swif.panel.create_directive('patrimoine_equipment', undefined, linked);
        directive.templateUrl = 'partials/patrimoine/panel-patrimoine-equipment.html';
        return directive;
    }

})();
